module.exports = __webpack_public_path__ + "img/illustration-signup.68cc03cc.jpg";